import { DeviceCommand, RolePermission } from "@core/types";

export const COMMAND_LIST = {
    reboot: {
        name: "Reboot",
        translateKey: "COMMAND_DROPDOWN.REBOOT",
        icon: "icon-refresh-cw",
        privilegedId: RolePermission.COMMAND_REBOOT
    },
    powerSwitch: {
        name: "Power Switch",
        translateKey: "COMMAND_DROPDOWN.POWER_SWITCH",
        icon: "icon-toggle-left",
        privilegedId: RolePermission.COMMAND_REBOOT
    },
    restoreToDefault: {
        name: "Restore to Default",
        translateKey: "COMMAND_DROPDOWN.RESTORE_TO_DEFAULT",
        icon: "icon-corner-down-left",
        privilegedId: RolePermission.COMMAND_RESTORE
    },
    upgradeFirmware: {
        name: "Upgrade Firmware",
        translateKey: "COMMAND_DROPDOWN.UPGRADE_FIRMWARE",
        icon: "icon-upload",
        privilegedId: RolePermission.COMMAND_UPGRADE_FW
    },
    upgradeConfiguration: {
        name: "Upgrade Configuration",
        translateKey: "COMMAND_DROPDOWN.UPGRADE_CONFIGURATION",
        icon: "icon-upload",
        privilegedId: RolePermission.COMMAND_UPGRADE_CFG
    },
    backupConfiguration: {
        name: "Backup Configuration",
        translateKey: "COMMAND_DROPDOWN.BACKUP_CONFIGURATION",
        icon: "icon-copy",
        privilegedId: RolePermission.COMMAND_BACKUP_CFG
    },
    backupSerialLog: {
        name: "Backup Serial Logs",
        translateKey: "COMMAND_DROPDOWN.BACKUP_SERIAL_LOGS",
        icon: "icon-copy",
        privilegedId: RolePermission.COMMAND_BACKUP_CFG
    },
    diagnosticTool: {
        name: "Diagnostic Tool",
        translateKey: "COMMAND_DROPDOWN.DIAGNOSTIC_TOOL",
        icon: "icon-activity",
        privilegedId: RolePermission.COMMAND_DIAGNOSTIC
    },
    pingUrl: {
        name: "Ping URL",
        translateKey: "COMMAND_DROPDOWN.PING_URL",
        icon: "icon-loader",
        privilegedId: RolePermission.COMMAND_DIAGNOSTIC
    },
    udpTest: {
        name: "UDP Testing",
        translateKey: "COMMAND_DROPDOWN.UDP_TESTING",
        icon: "icon-shuffle",
        privilegedId: RolePermission.COMMAND_DIAGNOSTIC
    },
    capturePDNPacket: {
        name: "PDN Packet Capture",
        translateKey: "COMMAND_DROPDOWN.PDN_PACKET_CAPTURE",
        icon: "icon-monitor",
        privilegedId: RolePermission.COMMAND_DIAGNOSTIC
    },
    upgradeModule: {
        name: "Upgrade Module",
        translateKey: "COMMAND_DROPDOWN.UPGRADE_MODULE",
        icon: "icon-upload",
        privilegedId: RolePermission.COMMAND_UPGRADE_FW
    },
    cbsd: {
        name: "CBSD",
        translateKey: "COMMAND_DROPDOWN.CBSD",
        icon: "icon-pocket",
        privilegedId:  RolePermission.COMMAND_CBSD,
        children: [
            {
                key: "cbsdDeregister",
                name: "Deregister",
                translateKey: "COMMAND_DROPDOWN.CBSD_DEREGISTER",
                icon: "icon-link-2",
                privilegedId: RolePermission.COMMAND_CBSD
            },
            {
                key: "cbsdRelinquishment",
                name: "Relinquishment",
                translateKey: "COMMAND_DROPDOWN.CBSD_RELINQUISHMENT",
                icon: "icon-scissors",
                privilegedId: RolePermission.COMMAND_CBSD
            },
            {
                key: "cbsdGrantRenew",
                name: "Grant Renew",
                translateKey: "COMMAND_DROPDOWN.CBSD_GRANT_RENEW",
                icon: "icon-log-in",
                privilegedId: RolePermission.COMMAND_CBSD
            },
            {
                key: "cbsdCpiPrivateKey",
                name: "CPI Private Key",
                translateKey: "COMMAND_DROPDOWN.CBSD_CPI_PRIVATE_KEY",
                icon: "icon-lock",
                privilegedId: RolePermission.COMMAND_CBSD
            }
        ]
    }
};

export const CBSD_COMMAND: { [key: string]: DeviceCommand.CBSD_DEREGISTER | DeviceCommand.CBSD_RELINQUISHMENT | DeviceCommand.CBSD_GRANT_RENEW } = {
    cbsdDeregister: DeviceCommand.CBSD_DEREGISTER,
    cbsdRelinquishment: DeviceCommand.CBSD_RELINQUISHMENT,
    cbsdGrantRenew: DeviceCommand.CBSD_GRANT_RENEW
};
